// import React, { useRef, useState } from "react";
// import { Formik, Field, Form } from "formik";
// import {
//     SubmitBtn,
//     SideCancelBtn,
//     Wrapper,
//     ScrollableContent,
//     ActionSection,
//     FieldWrappers,
//     CalendarIcon,
//     RupeeIcon,
//     CombineInputGroup,
// } from "../Styles/InputStyles";
// import { Select, MenuItem } from "@mui/material";
// import { MdClose } from "react-icons/md";
// import { FaUserPlus } from "react-icons/fa";
// import tw from "tailwind-styled-components";
// import * as Yup from "yup";
// import { toast } from "react-toastify";
// import { getUserType } from "../../helpers";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { FaRegCalendar } from "react-icons/fa";
// import moment from "moment";
// import CategoryCard from "../CategoryCard";
// import PaidToUserModal from "../Expenses/PaidToUserModal";
// const MaintenanceDetail = ({
//     maintenanceDetailMutate,
//     maintenanceDetailLoading,
//     vendorList,
//     setShowAddVendorForm,
//     showAddVendorForm,
//     expenseData,
//     addVendorMutate,
//     addVendorLoading,
//     setVendorMobile,
//     vendorMobile,
//     vendorName,
//     setVendorName,
//     handleMaintenanceClose,
//     handleVendorFormClose,
//     selectedProperty,
//     assetId,
//     propId
// }) => {
//     const formikRef = useRef(null)
//     const [calendarOpen, setCalendarOpen] = useState(false);
//     const [lastMaintenanceCalendarOpen, setLastMaintenanceCalendarOpen] = useState(false);
//     const [selectedVendor, setSelectedVendor] = useState('')
//     const [showSelectVendorModal, setShowSelectVendorModal] = useState(false)
//     const initialValues = {
//         lastMaintenance: "",
//         nextMaintenance: "",
//         description: "",
//         cost: "",
//         assignVendor: "",
//         propId: selectedProperty?.propId || propId,
//         assetId: selectedProperty?.assetId || assetId,
//     };

//     const validationSchema = Yup.object({
//         lastMaintenance: Yup.date()
//             .required("Select Last Maintenance Date")
//             .max(new Date(), "Last Maintenance cannot be a future date"),
//         nextMaintenance: Yup.date()
//             .required("Select Next Maintenance Date")
//             .min(
//                 Yup.ref("lastMaintenance"),
//                 "Next Maintenance must be after Last Maintenance"
//             ),
//         cost: Yup.number().required("Cost is required").typeError('Must be a number')
//             .min(1, 'Minimum value is 1')
//             .max(1000000, 'Maximum value is 1000000'),
//         assignVendor: Yup.number().required("Vendor is required")
//     });

//     const handleSelectedVendor = (selectedOption) => {
//         setSelectedVendor(selectedOption)
//         if (formikRef.current) {
//             formikRef.current.setFieldValue("assignVendor", selectedOption.id)
//         }
//     }

//     const handlePaidToSave = (paid) => {
//         handleSelectedVendor(paid)
//         setShowSelectVendorModal(false)
//     }

//     const handleSubmit = (values) => {
//         const selectedVendor = (vendorList || expenseData?.vendors)?.find(v => v.id === values.assignVendor);
//         maintenanceDetailMutate({
//             lastMaintenance: values.lastMaintenance,
//             nextMaintenance: values.nextMaintenance,
//             description: values.description,
//             cost: Number(values.cost),
//             assignedToId: values.assignVendor,
//             assignedToType: selectedVendor?.userType,
//             propId: selectedProperty?.propId || Number(propId),
//             assetId: selectedProperty?.assetId || Number(assetId),
//         });
//     };

//     const addNewVendor = () => {
//         if (!vendorName) {
//             toast.error("Please fill vendor name.");
//             return;
//         }

//         addVendorMutate({
//             name: vendorName,
//             mobile: vendorMobile
//         })

//     };
//     const vendorsType3 = (vendorList || expenseData?.vendors)?.filter(v => v.userType === 3);
//     const vendorsType4 = (vendorList || expenseData?.vendors)?.filter(v => v.userType === 4);
//     return (
//         <Container>
//             <Header>
//                 <Title>Maintenance Detail</Title>
//                 <CloseButton onClick={handleMaintenanceClose}>
//                     <MdClose size={24} />
//                 </CloseButton>
//             </Header>
//             <Content>
//                 <Formik
//                     initialValues={initialValues}
//                     onSubmit={handleSubmit}
//                     validationSchema={validationSchema}
//                     innerRef={formikRef}
//                 >
//                     {({ values, setFieldValue, errors, touched }) => (
//                         <Form>
//                             <ScrollableContent className="max-h-[calc(100vh-140px)]">
//                                 <Wrapper>
//                                     <InputGroup>
//                                         <Label htmlFor="lastMaintenance">Last Maintenance *</Label>
//                                         <FieldWrappers>
//                                             <DatePicker
//                                                 selected={values.lastMaintenance ? new Date(values.lastMaintenance) : null}
//                                                 onChange={(date) => {
//                                                     setFieldValue("lastMaintenance", moment(date).format("YYYY-MM-DD"));
//                                                     setLastMaintenanceCalendarOpen(false);
//                                                 }}
//                                                 onClickOutside={() => setLastMaintenanceCalendarOpen(false)}
//                                                 onSelect={() => setLastMaintenanceCalendarOpen(false)}
//                                                 open={lastMaintenanceCalendarOpen}
//                                                 onInputClick={() => setLastMaintenanceCalendarOpen(true)}
//                                                 dateFormat="yyyy-MM-dd"
//                                                 className="cursor-pointer items-center"
//                                                 placeholderText="Select last maintenance date"
//                                                 showIcon
//                                                 icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
//                                                 showPopperArrow={false}
//                                                 maxDate={new Date()}
//                                                 onFocus={(e) => e.target.blur()}
//                                                 wrapperClassName="w-full"
//                                                 name="lastMaintenance"
//                                                 id="lastMaintenance"
//                                                 autoComplete="off"
//                                                 portalId="root-portal"
//                                                 popperClassName="react-datepicker-popper"
//                                             />
//                                         </FieldWrappers>
//                                         {errors.lastMaintenance && touched.lastMaintenance && (
//                                             <ErrorText>{errors.lastMaintenance}</ErrorText>
//                                         )}
//                                     </InputGroup>

//                                     <InputGroup>
//                                         <Label htmlFor="cost">Maintenance Cost *</Label>
//                                         <FieldWrappers>
//                                             <RupeeIcon />
//                                             <Field
//                                                 type="text"
//                                                 name="cost"
//                                                 id="cost"
//                                                 className="pl-5"
//                                                 onKeyPress={(e) =>
//                                                     /[^0-9]/.test(e.key) && e.preventDefault()
//                                                 }
//                                             />
//                                         </FieldWrappers>
//                                         {errors.cost && touched.cost && (
//                                             <ErrorText>{errors.cost}</ErrorText>
//                                         )}
//                                     </InputGroup>

//                                     <InputGroup>
//                                         <Label htmlFor="nextMaintenance">Next Maintenance *</Label>
//                                         <FieldWrappers>
//                                             {/* <CalendarIcon />
//                                             <Field
//                                                 type="date"
//                                                 name="nextMaintenance"
//                                                 id="nextMaintenance"
//                                                 className="pl-6"
//                                                 min={values.lastMaintenance || ""}
//                                             /> */}
//                                             <DatePicker
//                                                 selected={values.nextMaintenance ? new Date(values.nextMaintenance) : null}
//                                                 onChange={(date) => {
//                                                     setFieldValue("nextMaintenance", moment(date).format("YYYY-MM-DD"));
//                                                     setCalendarOpen(false);
//                                                 }}
//                                                 onClickOutside={() => setCalendarOpen(false)}
//                                                 onSelect={() => setCalendarOpen(false)}
//                                                 open={calendarOpen}
//                                                 onInputClick={() => setCalendarOpen(true)}
//                                                 dateFormat="yyyy-MM-dd"
//                                                 className="cursor-pointer items-center"
//                                                 placeholderText="Select next maintenance date"
//                                                 showIcon
//                                                 icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
//                                                 showPopperArrow={false}
//                                                 minDate={values.lastMaintenance ? new Date(values.lastMaintenance) : null}
//                                                 onFocus={(e) => e.target.blur()}
//                                                 wrapperClassName="w-full"
//                                                 name="nextMaintenance"
//                                                 id="nextMaintenance"
//                                                 autoComplete="off"
//                                                 portalId="root-portal"
//                                                 popperClassName="react-datepicker-popper"
//                                             />
//                                         </FieldWrappers>
//                                         {errors.nextMaintenance && touched.nextMaintenance && (
//                                             <ErrorText>{errors.nextMaintenance}</ErrorText>
//                                         )}
//                                     </InputGroup>


//                                     {!showAddVendorForm && (
//                                         <><InputGroup>
//                                             <Label htmlFor="assignVendor">Vendor *</Label>
//                                             <CategoryCard type="button" selectedCategory={selectedVendor} title="Vendor" onClick={() => setShowSelectVendorModal(true)} />
//                                             {/* <Select
//         id="assignVendor"
//         name="assignVendor"
//         fullWidth
//         value={values.assignVendor}
//         onChange={(e) => {
//             if (e.target.value === "add_vendor") {
//                 setShowAddVendorForm(true);
//             } else {
//                 setFieldValue("assignVendor", e.target.value);
//                 setShowAddVendorForm(false);
//             }
//         }}
//         className="w-full px-2"
//         style={{ height: "46px" }}
//         renderValue={(selected) => {
//             const selectedVendor = (vendorList || expenseData?.vendors)?.find(v => v.id === selected);
//             return selectedVendor ? selectedVendor.name : "";
//         }}
//     >
//         <MenuItem value="add_vendor">
//             <FaUserPlus className="mr-1" /> Add Vendor
//         </MenuItem>
//         {(vendorList || expenseData?.vendors)?.map((vendor) => (
//             <MenuItem key={vendor.id} value={vendor.id}>

//                 <div className="flex flex-col">
//                     <span className='text-gray-600 text-md'>{vendor.name}</span>
//                     <span className="text-primary-color text-sm">{getUserType(vendor.userType || 0)}</span>
//                 </div>
//             </MenuItem>
//         ))}
//     </Select> */}
//                                             {errors.assignVendor && touched.assignVendor && (
//                                                 <ErrorText>{errors.assignVendor}</ErrorText>
//                                             )}
//                                         </InputGroup><div className="-mt-2 flex items-end justify-end">
//                                                 <Vendor
//                                                     type="button"
//                                                     onClick={() => {
//                                                         setShowAddVendorForm(true);
//                                                     }}
//                                                 >
//                                                     <FaUserPlus className="mr-1 mt-0.5" />
//                                                     Add Vendor
//                                                 </Vendor>
//                                             </div></>
//                                     )}

//                                     {showAddVendorForm && (
//                                         <div className="border px-2 rounded-md">
//                                             <Wrapper>
//                                                 <CombineInputGroup>
//                                                     <InputGroup>
//                                                         <Label htmlFor="fullName">Vendor Name *</Label>
//                                                         <FieldWrappers>
//                                                             <Field
//                                                                 type="text"
//                                                                 name="fullName"
//                                                                 id="fullName"
//                                                                 value={vendorName}
//                                                                 onChange={(e) => setVendorName(e.target.value)}
//                                                             />
//                                                         </FieldWrappers>
//                                                     </InputGroup>
//                                                     <InputGroup>
//                                                         <Label htmlFor="mobile">Vendor Mobile</Label>
//                                                         <FieldWrappers>
//                                                             <Field
//                                                                 type="text"
//                                                                 name="mobile"
//                                                                 id="mobile"
//                                                                 value={vendorMobile}
//                                                                 maxLength={10}
//                                                                 onChange={(e) => setVendorMobile(e.target.value)}
//                                                             />
//                                                         </FieldWrappers>
//                                                     </InputGroup>
//                                                 </CombineInputGroup>

//                                             </Wrapper>
//                                             <AddVendorBtn>
//                                                 <AddVendorCancelBtn
//                                                     onClick={handleVendorFormClose}
//                                                 >
//                                                     Cancel
//                                                 </AddVendorCancelBtn>
//                                                 <AddVendorSubmitBtn type="button" onClick={addNewVendor} disabled={addVendorLoading}>
//                                                     {addVendorLoading ? "Loading..." : "Add Vendor"}
//                                                 </AddVendorSubmitBtn>
//                                             </AddVendorBtn>
//                                         </div>
//                                     )}
//                                     <InputGroup>
//                                         <Label htmlFor="description">Description </Label>

//                                         <Field
//                                             as={Textarea}
//                                             id="description"
//                                             name="description"
//                                             rows={5}
//                                             placeholder="Enter Description (e.g., Serial Number or Product Specifications)"
//                                         />

//                                     </InputGroup>
//                                 </Wrapper>
//                             </ScrollableContent>
//                             <ActionSection>
//                                 <SideCancelBtn onClick={handleMaintenanceClose}>
//                                     Cancel
//                                 </SideCancelBtn>
//                                 <SubmitBtn type="submit" disabled={maintenanceDetailLoading}>
//                                     {maintenanceDetailLoading ? "Submitting..." : "Submit"}
//                                 </SubmitBtn>
//                             </ActionSection>
//                             <PaidToUserModal
//                                 isOpen={showSelectVendorModal}
//                                 onClose={() => setShowSelectVendorModal(false)}
//                                 onSelect={handlePaidToSave}
//                                 options={vendorList || expenseData?.vendors}
//                                 landlordList={expenseData?.landlords}
//                                 selectedPaidTo={selectedVendor}
//                                 title="Select Vendor"
//                             />
//                         </Form>
//                     )}
//                 </Formik>
//             </Content>
//         </Container>
//     );
// };

// const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
// const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
// const Label = tw.label`text-sm text-gray-600 font-normal mb-1.5`;
// const Container = tw.div`bg-white w-full h-full flex flex-col`;
// const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
// const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
// const CloseButton = tw.button`text-white`;
// const Content = tw.div`px-6 h-full flex flex-col justify-between relative`;
// const AddVendorBtn = tw.div`bg-white flex justify-end py-4 px-2 gap-2`;
// const AddVendorSubmitBtn = tw.button`text-xs w-20 h-7 items-center  bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;
// const AddVendorCancelBtn = tw.button`text-xs w-20 h-7 grid place-items-center text-gray-600 `;
// const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;
// const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
// export default MaintenanceDetail;


import React, { useRef, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    FieldWrappers,
    CalendarIcon,
    RupeeIcon,
    CombineInputGroup,
} from "../Styles/InputStyles";
import { Select, MenuItem } from "@mui/material";
import { MdClose } from "react-icons/md";
import { FaUserPlus } from "react-icons/fa";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { getUserType } from "../../helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendar } from "react-icons/fa";
import moment from "moment";
import CategoryCard from "../CategoryCard";
import PaidToUserModal from "../Expenses/PaidToUserModal";

const MaintenanceDetail = ({
    maintenanceDetailMutate,
    maintenanceDetailLoading,
    vendorList,
    setShowAddVendorForm,
    showAddVendorForm,
    expenseData,
    addVendorMutate,
    addVendorLoading,
    setVendorMobile,
    vendorMobile,
    vendorName,
    setVendorName,
    handleMaintenanceClose,
    handleVendorFormClose,
    selectedProperty,
    assetId,
    propId
}) => {
    const formikRef = useRef(null)
    const [calendarOpen, setCalendarOpen] = useState(false);
    const [lastMaintenanceCalendarOpen, setLastMaintenanceCalendarOpen] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null)
    const [showSelectVendorModal, setShowSelectVendorModal] = useState(false)

    const initialValues = {
        lastMaintenance: "",
        nextMaintenance: "",
        description: "",
        cost: "",
        assignVendor: "",
        propId: selectedProperty?.propId || propId,
        assetId: selectedProperty?.assetId || assetId,
    };

    const validationSchema = Yup.object({
        lastMaintenance: Yup.date()
            .required("Select Last Maintenance Date")
            .max(new Date(), "Last Maintenance cannot be a future date"),
        nextMaintenance: Yup.date()
            .required("Select Next Maintenance Date")
            .min(
                Yup.ref("lastMaintenance"),
                "Next Maintenance must be after Last Maintenance"
            ),
        cost: Yup.number().required("Cost is required").typeError('Must be a number')
            .min(1, 'Minimum value is 1')
            .max(1000000, 'Maximum value is 1000000'),
        assignVendor: Yup.number().required("Vendor is required")
    });

    const handleSelectedVendor = (selectedUser) => {
        setSelectedVendor(selectedUser)
        if (formikRef.current) {
            formikRef.current.setFieldValue("assignVendor", selectedUser.id)
        }
    }

    const handlePaidToSave = (user) => {
        handleSelectedVendor(user)
        setShowSelectVendorModal(false)
    }

    const handleSubmit = (values) => {
        if (!selectedVendor) {
            toast.error("Please select a vendor/landlord");
            return;
        }

        maintenanceDetailMutate({
            lastMaintenance: values.lastMaintenance,
            nextMaintenance: values.nextMaintenance,
            description: values.description,
            cost: Number(values.cost),
            assignedToId: values.assignVendor,
            assignedToType: selectedVendor.userType,
            propId: selectedProperty?.propId || Number(propId),
            assetId: selectedProperty?.assetId || Number(assetId),
        });
    };

    const addNewVendor = () => {
        if (!vendorName) {
            toast.error("Please fill vendor name.");
            return;
        }

        addVendorMutate({
            name: vendorName,
            mobile: vendorMobile
        })
    };

    const getSelectedCategoryDisplay = () => {
        if (selectedVendor) {
            return {
                label: selectedVendor.name,
                value: selectedVendor.id
            };
        }
        return null;
    };

    return (
        <Container>
            <Header>
                <Title>Maintenance Detail</Title>
                <CloseButton onClick={handleMaintenanceClose}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            <Content>
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}
                    innerRef={formikRef}
                >
                    {({ values, setFieldValue, errors, touched }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="lastMaintenance">Last Maintenance *</Label>
                                        <FieldWrappers>
                                            <DatePicker
                                                selected={values.lastMaintenance ? new Date(values.lastMaintenance) : null}
                                                onChange={(date) => {
                                                    setFieldValue("lastMaintenance", moment(date).format("YYYY-MM-DD"));
                                                    setLastMaintenanceCalendarOpen(false);
                                                }}
                                                onClickOutside={() => setLastMaintenanceCalendarOpen(false)}
                                                onSelect={() => setLastMaintenanceCalendarOpen(false)}
                                                open={lastMaintenanceCalendarOpen}
                                                onInputClick={() => setLastMaintenanceCalendarOpen(true)}
                                                dateFormat="yyyy-MM-dd"
                                                className="cursor-pointer items-center"
                                                placeholderText="Select last maintenance date"
                                                showIcon
                                                icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                showPopperArrow={false}
                                                maxDate={new Date()}
                                                onFocus={(e) => e.target.blur()}
                                                wrapperClassName="w-full"
                                                name="lastMaintenance"
                                                id="lastMaintenance"
                                                autoComplete="off"
                                                portalId="root-portal"
                                                popperClassName="react-datepicker-popper"
                                            />
                                        </FieldWrappers>
                                        {errors.lastMaintenance && touched.lastMaintenance && (
                                            <ErrorText>{errors.lastMaintenance}</ErrorText>
                                        )}
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="cost">Maintenance Cost *</Label>
                                        <FieldWrappers>
                                            <RupeeIcon />
                                            <Field
                                                type="text"
                                                name="cost"
                                                id="cost"
                                                className="pl-5"
                                                onKeyPress={(e) =>
                                                    /[^0-9]/.test(e.key) && e.preventDefault()
                                                }
                                            />
                                        </FieldWrappers>
                                        {errors.cost && touched.cost && (
                                            <ErrorText>{errors.cost}</ErrorText>
                                        )}
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="nextMaintenance">Next Maintenance *</Label>
                                        <FieldWrappers>
                                            <DatePicker
                                                selected={values.nextMaintenance ? new Date(values.nextMaintenance) : null}
                                                onChange={(date) => {
                                                    setFieldValue("nextMaintenance", moment(date).format("YYYY-MM-DD"));
                                                    setCalendarOpen(false);
                                                }}
                                                onClickOutside={() => setCalendarOpen(false)}
                                                onSelect={() => setCalendarOpen(false)}
                                                open={calendarOpen}
                                                onInputClick={() => setCalendarOpen(true)}
                                                dateFormat="yyyy-MM-dd"
                                                className="cursor-pointer items-center"
                                                placeholderText="Select next maintenance date"
                                                showIcon
                                                icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                showPopperArrow={false}
                                                minDate={values.lastMaintenance ? new Date(values.lastMaintenance) : null}
                                                onFocus={(e) => e.target.blur()}
                                                wrapperClassName="w-full"
                                                name="nextMaintenance"
                                                id="nextMaintenance"
                                                autoComplete="off"
                                                portalId="root-portal"
                                                popperClassName="react-datepicker-popper"
                                            />
                                        </FieldWrappers>
                                        {errors.nextMaintenance && touched.nextMaintenance && (
                                            <ErrorText>{errors.nextMaintenance}</ErrorText>
                                        )}
                                    </InputGroup>

                                    {!showAddVendorForm && (
                                        <>
                                            <InputGroup>
                                                <Label htmlFor="assignVendor">Vendor *</Label>
                                                <CategoryCard
                                                    type="button"
                                                    selectedCategory={getSelectedCategoryDisplay()}
                                                    title="Vendor"
                                                    onClick={() => setShowSelectVendorModal(true)}
                                                />
                                                {errors.assignVendor && touched.assignVendor && (
                                                    <ErrorText>{errors.assignVendor}</ErrorText>
                                                )}
                                            </InputGroup>
                                            <div className="-mt-2 flex items-end justify-end">
                                                <Vendor
                                                    type="button"
                                                    onClick={() => {
                                                        setShowAddVendorForm(true);
                                                    }}
                                                >
                                                    <FaUserPlus className="mr-1 mt-0.5" />
                                                    Add Vendor
                                                </Vendor>
                                            </div>
                                        </>
                                    )}

                                    {showAddVendorForm && (
                                        <div className="border px-2 rounded-md">
                                            <Wrapper>
                                                <CombineInputGroup>
                                                    <InputGroup>
                                                        <Label htmlFor="fullName">Vendor Name *</Label>
                                                        <FieldWrappers>
                                                            <Field
                                                                type="text"
                                                                name="fullName"
                                                                id="fullName"
                                                                value={vendorName}
                                                                onChange={(e) => setVendorName(e.target.value)}
                                                            />
                                                        </FieldWrappers>
                                                    </InputGroup>
                                                    <InputGroup>
                                                        <Label htmlFor="mobile">Vendor Mobile</Label>
                                                        <FieldWrappers>
                                                            <Field
                                                                type="text"
                                                                name="mobile"
                                                                id="mobile"
                                                                value={vendorMobile}
                                                                maxLength={10}
                                                                onChange={(e) => setVendorMobile(e.target.value)}
                                                            />
                                                        </FieldWrappers>
                                                    </InputGroup>
                                                </CombineInputGroup>
                                            </Wrapper>
                                            <AddVendorBtn>
                                                <AddVendorCancelBtn
                                                    onClick={handleVendorFormClose}
                                                >
                                                    Cancel
                                                </AddVendorCancelBtn>
                                                <AddVendorSubmitBtn type="button" onClick={addNewVendor} disabled={addVendorLoading}>
                                                    {addVendorLoading ? "Loading..." : "Add Vendor"}
                                                </AddVendorSubmitBtn>
                                            </AddVendorBtn>
                                        </div>
                                    )}

                                    <InputGroup>
                                        <Label htmlFor="description">Description</Label>
                                        <Field
                                            as={Textarea}
                                            id="description"
                                            name="description"
                                            rows={5}
                                            placeholder="Enter Description (e.g., Serial Number or Product Specifications)"
                                        />
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn onClick={handleMaintenanceClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={maintenanceDetailLoading}>
                                    {maintenanceDetailLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>

                            <PaidToUserModal
                                isOpen={showSelectVendorModal}
                                onClose={() => setShowSelectVendorModal(false)}
                                onSelect={handlePaidToSave}
                                options={vendorList || expenseData?.vendors}
                                landlordList={expenseData?.landlords}
                                selectedPaidTo={selectedVendor}
                                title="Select Vendor"
                            />
                        </Form>
                    )}
                </Formik>
            </Content>
        </Container>
    );
};

const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-600 font-normal mb-1.5`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-6 h-full flex flex-col justify-between relative`;
const AddVendorBtn = tw.div`bg-white flex justify-end py-4 px-2 gap-2`;
const AddVendorSubmitBtn = tw.button`text-xs w-20 h-7 items-center  bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;
const AddVendorCancelBtn = tw.button`text-xs w-20 h-7 grid place-items-center text-gray-600 `;
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`

export default MaintenanceDetail;